// extracted by mini-css-extract-plugin
export default {"weather":"style_weather__E1RCW","timeContainer":"style_timeContainer__uqJkQ","cardContainer":"style_cardContainer__HdbpJ","card":"style_card__gjIz6"};